module.exports = __webpack_public_path__ + "img/长方形.6965019d.jpg";